export default __webpack_public_path__ + "locales/ko-KR/Common.json?hash=9f4ed32b0f1773f3fe241534df6f553e";